import { Injectable, Input } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from 'src/environments/environment';

import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BackOfficeHome {
    public url: string;
    public NotaCredito: any;
    public eventoActualiazarVehiculo = new BehaviorSubject(false);
    public actualizarVehiculoXEsquema = this.eventoActualiazarVehiculo.asObservable();
    constructor(private _http: HttpClient, public jwtHelper: JwtHelperService) {
        this.url = environment.urlAddressHome;
    }

    vehiculoActualizadoDesdeEsquema(actualizar:boolean){
        this.eventoActualiazarVehiculo.next(actualizar);
    }

    buscarCliente(numeroDocumento: string,
        tipoDocumentoID: string,
        tagID: string,
        patente: string,
        apellido: string,
        razonSocial: string,
        esNatural: boolean) {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');

        if (numeroDocumento === '') {
            numeroDocumento = null;
        }
        if (tipoDocumentoID === '') {
            tipoDocumentoID = null;
        }
        if (tagID === '') {
            tagID = null;
        }
        if (patente === '') {
            patente = null;
        }
        if (apellido === '') {
            apellido = null;
        }
        if (razonSocial === '') {
            razonSocial = null;
        }

        return this._http.get(environment.urlAddressHome + 'clientes/buscar/'
            + usuarioID + '/' + null + '/' + numeroDocumento + '/'
            + tipoDocumentoID + '/' + tagID + '/' + patente + '/'
            + apellido + '/' + razonSocial + '/' + esNatural,
            {
                headers: new HttpHeaders({
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json'
                })
            });
    }

    buscarFactura(facturaFolio: number, clienteID: number) {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');
        // const decode = jwt_decode(token);

        return this._http.get(environment.urlAddressHome + 'documentos/obtenerFactura/' + usuarioID + '/' + facturaFolio + '/' + clienteID,
            {
                headers: new HttpHeaders({
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json'
                })
            });
    }

    crearNota(facturaID: string, tipoDocumentoID: string, clienteID: string,
        descripcion: string, montobruto: string, unidad: string, montoSinIVA: string, facturaTipoID: string) {

        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');

        return this._http.post(environment.urlAddressHome + 'documentos/agregarNota/',
            {
                clienteID, facturaID, tipoDocumentoID,
                usuarioID,facturaTipoID, detalle: [{
                    descripcion, montobruto,
                    unidad, montoSinIVA
                }]
            }, {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json'
            })
        });
    }


    obtenerDatosCliente(clienteID: string) {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');
        // const clienteID = sessionStorage.getItem('clienteID');
        // const decode = jwt_decode(token);

        return this._http.get(environment.urlAddressHome + 'clientes/datosCliente/' + usuarioID + '/' + clienteID,
            {
                headers: new HttpHeaders({
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json'
                })
            });
    }


    actualizarDatosCliente(cliente: any) {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');
        // tslint:disable-next-line: no-unused-expression


        const httpHeaders = new HttpHeaders({
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        });

        return this._http.post<any>(environment.urlAddressHome + 'clientes/actualizar/', JSON.stringify(cliente),
            {
                headers: httpHeaders
            }
        );
    }


    crearBeneficioBancario(EsquemaPagoBeneficiosCrear: any) {
        const token = sessionStorage.getItem('token');
        // tslint:disable-next-line: no-unused-expression
        const httpHeaders = new HttpHeaders({
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        });

        return this._http.post<any>(environment.urlAddressHome + 'esquemasPago/crearBeneficioBancario/', JSON.stringify(EsquemaPagoBeneficiosCrear),
            {
                headers: httpHeaders
            }
        );
    }

    cargarDatos(clienteID: number) {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');

        return this._http.get(environment.urlAddressHome + 'clientes/datosCliente/' + usuarioID + '/' + clienteID,
            {

                headers: new HttpHeaders({
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json'
                })
            });
    }


    obtenerVehiculos(clienteID: number) {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');

        return this._http.get(environment.urlAddressHome + 'vehiculos/listar/' + usuarioID + '/' + clienteID,
            {
                headers: new HttpHeaders({
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json'
                })
            });
    }

    esquemasdepago(clienteID: number) {
        const token = sessionStorage.getItem('token');

        return this._http.get(environment.urlAddressHome + 'esquemasPago/listar/' + clienteID,
            {
                headers: new HttpHeaders({
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json'
                })
            });
    }


    actualizarVehiculo(vehiculo: any) {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');
        // tslint:disable-next-line: no-unused-expression
        const httpHeaders = new HttpHeaders({
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        });

        return this._http.post<any>(environment.urlAddressHome + 'vehiculos/actualizar/', JSON.stringify(vehiculo),
            {
                headers: httpHeaders
            }
        );
    }

    agregarVehiculo(vehiculo: any) {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');
        // tslint:disable-next-line: no-unused-expression
        const httpHeaders = new HttpHeaders({
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        });

        return this._http.post<any>(environment.urlAddressHome + 'vehiculos/agregar/', JSON.stringify(vehiculo),
            {
                headers: httpHeaders
            }
        );
    }


    cambiarTag(tag: any) {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');
        // tslint:disable-next-line: no-unused-expression
        const httpHeaders = new HttpHeaders({
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        });

        return this._http.post<any>(environment.urlAddressHome + 'vehiculos/cambiarTag/', JSON.stringify(tag),
            {
                headers: httpHeaders
            }
        );
    }

    darBajaVehiculo(vehiculo: any) {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');
        // tslint:disable-next-line: no-unused-expression
        const httpHeaders = new HttpHeaders({
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        });

        return this._http.post<any>(environment.urlAddressHome + 'vehiculos/darBaja/', JSON.stringify(vehiculo),
            {
                headers: httpHeaders
            }
        );
    }

    obtenerDatosDomicilio() {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');
        const clienteID = sessionStorage.getItem('clienteID');
        return this._http.get(environment.urlAddressHome + 'domicilios/obtenerdomicilio/' + usuarioID + '/' + clienteID,
            {

                headers: new HttpHeaders({
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json'
                })
            });
    }


    actualizarDireccion(oDomicilio: any) {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');
        // tslint:disable-next-line: no-unused-expression
        const httpHeaders = new HttpHeaders({
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        });

        return this._http.post<any>(environment.urlAddressHome + 'domicilios/actualizar', JSON.stringify(oDomicilio),
            {
                headers: httpHeaders
            }
        );
    }



    obtenerPasos(esquemaPagoID: number, desde: string, hasta: string) {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');

        return this._http.get(environment.urlAddressHome + 'pasos/obtenerPasos/' + esquemaPagoID + '/' + desde + '/' + hasta,
            {
                headers: new HttpHeaders({
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json'
                })
            });
    }



    obtenerMovimientos(esquemaPagoID: number, desde: string, hasta: string) {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');

        return this._http.get(environment.urlAddressHome + 'pasos/movimientos/' + esquemaPagoID + '/' + desde + '/' + hasta,
            {
                headers: new HttpHeaders({
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json'
                })
            });
    }


    obtenerDocumentos(clienteID: number) {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');

        return this._http.get(environment.urlAddressHome + 'documentos/obtener/' + clienteID,
            {
                headers: new HttpHeaders({
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json'
                })
            });
    }

    obtenerArchivo(documentoID: number) {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');

        return this._http.get(environment.urlAddressHome + 'documentos/obtenerArchivo/' + documentoID,
            {
                headers: new HttpHeaders({
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json'
                })
            });
    }

    inicializarEsquemaPago(clienteID: number) {
        const token = sessionStorage.getItem('token');
        // const usuarioID = sessionStorage.getItem('usuarioID');

        return this._http.get(environment.urlAddressHome + 'esquemasPago/inicializar/' + clienteID, {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json'
            })
        });
    }

    obtenerEsquemaPago(esquemaPagoID: number) {
        const token = sessionStorage.getItem('token');
        // const usuarioID = sessionStorage.getItem('usuarioID');

        return this._http.get(environment.urlAddressHome + 'esquemasPago/datosObtener/' + esquemaPagoID, {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json'
            })
        });
    }


    actualizarEsquemaPago(esquemaPago: any) {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');
        // tslint:disable-next-line: no-unused-expression
        const httpHeaders = new HttpHeaders({
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        });

        return this._http.post<any>(environment.urlAddressHome + 'esquemasPago/actualizar/', JSON.stringify(esquemaPago),
            {
                headers: httpHeaders
            }
        );
    }

    agregarEsquemaPago(esquemaPago: any) {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');
        // tslint:disable-next-line: no-unused-expression
        const httpHeaders = new HttpHeaders({
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        });

        return this._http.post<any>(environment.urlAddressHome + 'esquemasPago/darAlta/', JSON.stringify(esquemaPago),
            {
                headers: httpHeaders
            }
        );
    }


}


